<template>
  <div class="navOutDiv">
    <navbar/>
    <transition name="fade-transform" mode="out-in">
      <router-view />
    </transition>
    <foot/>
  </div>
</template>
<script>
import Navbar from './navbar/index'
import foot from '@/layout/foot/index'
export default {
  name: 'Layout',
  components: { Navbar, foot }
}
</script>
<style>
  @import url('../../styles/reset.css');
</style>
<style lang="scss" scoped>
.navOutDiv{
  // display:flex;
  width:100%;
  // justify-content:center;
}
</style>
